import React, { useState, useEffect, forwardRef } from 'react';
import Grid from '@material-ui/core/Grid'
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import { ThemeProvider } from "@material-ui/core"
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import axios from 'axios'
import Alert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import { useSelector, useDispatch } from "react-redux";

//Download Template
import ePerformanceSapTemplate from '../UploadSapData/Template/ePerformanceSapData.xlsx';

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const apimst = axios.create({
    baseURL: 'MasterDetails'
})

function SapDataDetails(props) {
    const [data, setData] = useState([]);
    //for progress
    const [openLoader, setopenLoader] = useState(false);
    const [CreatedUserId, setCreatedUserId] = useState(props.loginuser.response.employeeId);
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [alertsuccess, setalertsuccess] = useState("Success");
    //const [alerterror, setalerterror] = useState("Alert");
    const [alertsuccessclass, setalertsuccessclass] = useState("bg-light-green clr-white");
    //const [alerterrorclass, setalerterrorclass] = useState("bg-red clr-white");
    //for alert msg
    const [open, setopen] = useState(false);
    const [openAlert, setopenAlert] = useState("");
    const [openClassName, setopenClassName] = useState("");
    const [openType, setopenType] = useState("");
    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);
    //table data
    var columns = [
        { title: 'id', field: 'id', hidden: true },
        { title: 'MRP Controller', field: 'mrpcontroller', editable: 'never' },
        { title: 'Wage Group', field: 'wageGroup', editable: 'never' },
        { title: 'Work Center Code', field: 'workctr', editable: 'never' },
        { title: 'Work Center Desciption', field: 'workcenterDesciption', editable: 'never' },
        { title: 'Material Code', field: 'material', editable: 'never' },
        { title: 'Material Description', field: 'materialDescription', editable: 'never' },
        { title: 'Group', field: 'grC', editable: 'never' },
        { title: 'Group Counter description', field: 'groupCounterdescription', editable: 'never' },
        { title: 'Operation Code', field: 'opAc', editable: 'never' },
        { title: 'Operation Desc', field: 'operationDesc', editable: 'never' },
        { title: 'Machine Setuptime', field: 'machineSetuptime', editable: 'onUpdate'},
        { title: 'Machine Runtime', field: 'machineRuntime', editable: 'onUpdate' },
        { title: 'Labour Setuptime', field: 'laboursetuptime', editable: 'onUpdate' },
        { title: 'Labour Runtime', field: 'labourruntime', editable: 'onUpdate' },
        { title: 'Base Quantity', field: 'baseQuantity', editable: 'onUpdate'}
    ]

    function showMsg(popen, popenAlert, popenClassName, popenType) {
        setopen(popen);
        setopenAlert(popenAlert);
        setopenClassName(popenClassName);
        setopenType(popenType);
    }

    function GetSapData() {
        setopenLoader(true);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
        };
        apimst.get("/getSAPData/", {
            headers: headers
        })
        .then(res => {
            setData(res.data);
           // console.log(res.data);
            setopenLoader(false);
        })
        .catch(error => {
            console.log("Error in hitting api : getSAPData")
            setopenLoader(false);
        })
    }

    //const SearchTable = (event) => {
    //    GetSapData();
    //};

    const handleRowUpdate = (newData, oldData, resolve) => {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let errorList = [];        
        if (parseFloat(newData.machineSetuptime) < -1) {
            errorList.push("enter valid machine setuptime");
        }
        if (parseFloat(newData.machineRuntime) < -1) {
            errorList.push("enter valid machine runtime");
        }
        if (parseFloat(newData.laboursetuptime) < -1) {
            errorList.push("enter valid labour setuptime");
        }
        if (parseFloat(newData.labourruntime) < -1) {
            errorList.push("enter valid labour runtime");
        }
        if (parseFloat(newData.baseQuantity) < -1) {
            errorList.push("enter valid base quantity");
        }

        if (errorList.length < 1) {
            let sapdata = {
                id: Number(newData.id),
                machineSetuptime: newData.machineSetuptime,
                machineRuntime: newData.machineRuntime,
                laboursetuptime: newData.laboursetuptime,
                labourruntime: newData.labourruntime,
                baseQuantity: newData.baseQuantity,
                modifiedBy: CreatedUserId,
            }
            apimst.put("/UpdateSAPData/", sapdata,{
                headers: headers
            })
                .then(res => {
                    if (res.data.result !== 1) {
                        errorList.push("");
                        setErrorMessages(errorList);
                        setIserror(false);
                        resolve();
                    }
                    else {
                        showMsg(true, "Data updated successfully.", alertsuccessclass, alertsuccess);
                        const dataUpdate = [...data];
                        const index = oldData.tableData.id;
                        dataUpdate[index] = newData;
                        setData([...dataUpdate]);
                        resolve();
                        setIserror(false);
                        setErrorMessages([]);
                    }
                })
                .catch(error => {
                    setErrorMessages(["Due to server error, we are unable to update the sap data. Please try again, later."]);
                    setIserror(true);
                    resolve();
                })

        } else {
            setErrorMessages(errorList);
            setIserror(true);
            resolve();
        }
    }

    useEffect(() => {
       GetSapData();
    }, [])

    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data">
                <Box paddingTop={{ xs: '5rem', sm: '2rem' }} className="">
                    <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1">SAP DATA</h3>
                </Box>
                <Grid container spacing={1} className="d-flex jc-center mb-2 bdr-radius">                    
                    <Grid item xs={12} sm={11} className="d-flex Width-100 ">
                        <a href={ePerformanceSapTemplate} style={{ color: '#FFF' }} download="ePerformanceSapData.xlsx">
                            <Button item className="ns-btn-primary mt-1">
                                <span><GetAppOutlinedIcon fontSize="large" /></span> SAP Data Upload Template
                            </Button>
                        </a>
                    </Grid>
                    <Grid item xs={12} sm={11} className="userManagement mt-1 mb-1">
                        <div>
                            {iserror &&
                                <Alert severity="error">
                                    {errorMessages.map((msg, i) => {
                                        return <div key={i}>{msg}</div>
                                    })}
                                </Alert>
                            }
                        </div>

                        <MaterialTable
                            title="SAP Data"
                            columns={columns}
                            data={data}
                            icons={tableIcons}
                            detailPanel={rowData => {
                                return (
                                    <div className="p-1 ml-1 detail-dashboard">
                                        <div>Unit  : {rowData.unit}</div>
                                        <div>MRT Unit : {rowData.mrtunit}</div>
                                        <div>LST Unit : {rowData.lstunit}</div>
                                        <div>LRT Unit : {rowData.lrtunit}</div>
                                    </div>
                                );
                            }}
                            options={{
                                pageSizeOptions: [30, 40, 50],    // rows selection options
                                pageSize: 50,
                                maxBodyHeight: 600,
                                exportButton: {
                                    csv: true,
                                    pdf: false
                                },
                                exportAllData: true,
                                exportFileName: "SAP Data"
                            }}
                            editable={{
                                onRowUpdate: (newData, oldData) =>
                                    new Promise((resolve) => {
                                        handleRowUpdate(newData, oldData, resolve);
                                    }),
                                //onRowAdd: (newData) =>
                                //    new Promise((resolve) => {
                                //        handleRowAdd(newData, resolve)
                                //    }),
                                //onRowDelete: (oldData) =>
                                //    new Promise((resolve) => {
                                //        handleRowDelete(oldData, resolve)
                                //    }),
                            }}
                            //actions={[
                            //    rowData => ({
                            //        icon: () => <Link to={"/SlipCreation?ID=" + `${window.btoa(rowData.id)}`}><EditOutlinedIcon fontSize="small" /></Link>,
                            //        tooltip: 'Edit',
                            //        onClick: (rowData),
                            //    })
                            //]}
                        />
                    </Grid>
                </Grid>
                <Dialog
                    open={openLoader}
                    //onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess"
                    PaperProps={{
                        style: {
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            borderColor: "transparent"
                        },
                    }}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
            </div>
        </ThemeProvider>
    );
}

export default SapDataDetails;